<icz-cross-reference-table
  [esslEntity]="document"
></icz-cross-reference-table>
